export default __webpack_public_path__ + "static/media/Hari-Jawaharlal.5a62f1e5.png";